/**
 * PWA service worker registration.
 * Call registerSW() once from index.js.
 */
export function registerSW() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL}/sw.js`)
        .then((reg) => console.log("[SW] Registered, scope:", reg.scope))
        .catch((err) => console.warn("[SW] Registration failed:", err));
    });
  }
}
